import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Link } from "@mui/material";
import SvgColor from "../svg-color";
import palette from "src/theme/palette";
import { useSettingsContext } from "../settings";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const { themeMode } = useSettingsContext();

  const logo = (
    <SvgColor
      src="/logo/white_nightz_icon_text.svg"
      sx={{
        width: 194,
        height: 48,
        cursor: "pointer",
        bgcolor:
          themeMode === "dark" ? "white" : palette("dark").background.default,
        ...sx,
      }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} to="/" sx={{ display: "contents" }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
